import { IApplicationState } from '../../types/redux';

const EMPTY_REGIONS: never[] = [];

export const getRegions = (state: IApplicationState) => state.developerV2?.regions || EMPTY_REGIONS;
